<template>
  <VmFormDesigner ref="vFormRef" :designer-config="designerConfig" :global-dsv="globalDsv">
    <!-- 设计器集成后端字段接口增加这个属性 :field-list-api="fieldListApi" -->
    <!-- <template #customToolButtons>
          <el-button>>自定义按钮</el-button>
        </template> -->
  </VmFormDesigner>
</template>

<script>
import { computed, getCurrentInstance, reactive, ref, toRefs, onMounted } from 'vue';
import VmFormDesigner from './components/form-designer/index.vue';

import test from './test';
export default {
  components: {
    VmFormDesigner,
    test,
  },
  name: 'App',
  setup() {
    const { proxy } = getCurrentInstance();
    const vFormRef = ref(null);

    const data = reactive({
      designerConfig: {
        // logoHeader: false,
        toolBoxStyle: 'top', //配置工具栏标签栏的显示的方式，top 或者 left
      },
      fieldListApi: {
        URL: '/field-api.json',
        headers: {
          //后端需要token请设置请求头对象，后端如不需要可不设置
        },
        labelKey: 'fieldLabel',
        nameKey: 'fieldName',
      },

      // 全局数据源变量

      globalDsv: {
        testApiHost: 'http://www.test.com/api',
      },
    });

    const submitForm = () => {
      vFormRef.value
        .getFormData()
        .then(formData => {
          // Form Validation OK
          alert(JSON.stringify(formData));
        })
        .catch(error => {
          // Form Validation failed
          proxy.$message.error(error);
        });
    };

    onMounted(() => {
      vFormRef.value.addEC('ecTest', {
        test: 'test',
      });
    });
    return {
      vFormRef,

      ...toRefs(data),
      submitForm,
    };
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
